import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Clickable, { ClickableProps } from "@insite/mobius/Clickable";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden/Hidden";
import Icon from "@insite/mobius/Icon";
import Printer from "@insite/mobius/Icons/Printer";
import Img from "@insite/mobius/Img";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import loadPODData from "@WhiteCap/Handlers/PODOrderHistory/PODHandler";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        podData: state.WhiteCap.podDataStore.PODData,
        isLoading: state.WhiteCap.podDataStore.isLoading,
    };
};

const mapDispatchToProps = {
    loadPODData,
};

interface OwnProps {
    onHandleClose: (event: React.SyntheticEvent) => void;
    modalIsOpen: boolean;
    poNumber: string;
}

export interface ProofOfDeliveryStyles {
    orderNumberText?: InjectableCss;
    printButton?: InjectableCss;
    tittleContainer?: InjectableCss;
    orderDetailsContainer?: GridContainerProps;
    firstGrid?: GridItemProps;
    secondGrid?: GridItemProps;
    thirdGrid?: GridItemProps;
    fourthtGrid?: GridItemProps;
    secondGridFirst?: InjectableCss;
    secondGridlast?: InjectableCss;
    secondGridFirstMain?: InjectableCss;
    orderTable?: InjectableCss;
    itemsHeader?: InjectableCss;
    uomHeader?: InjectableCss;
    qtyHeader?: InjectableCss;
    productPhoto?: InjectableCss;
    productImage?: GridItemProps;
    deliverdProductText?: InjectableCss;
    notesSignature?: InjectableCss;
    notes?: InjectableCss;
    signature?: InjectableCss;
    photoGallary?: GridContainerProps;
    lastInfo?: InjectableCss;
    signatureImage?: InjectableCss;
    printClickable?: ClickableProps;
    receivedText?: InjectableCss;
    podModal?: ModalPresentationProps;
    printIcon?: InjectableCss;
    receiveContainer?: InjectableCss;
    dateContainer?: InjectableCss;
    orderContainer?: InjectableCss;
    personName?: InjectableCss;
    date?: InjectableCss;
    nextPreviousContainer?: InjectableCss;
    previousContainer?: InjectableCss;
    nextContainer?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    podImage?: InjectableCss;
    getItByDate?: InjectableCss;
}

export const proofOfDeliveryStyles: ProofOfDeliveryStyles = {
    printIcon: {
        css: css`
            color: #005eaa;
        `,
    },
    podModal: {
        sizeVariant: "medium",
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
                color: #474747;
            `,
            modalContent: css`
                padding: 20px;
            `,
            scrim: css`
                background: transparent;
            `,
            modalBody: css`
                max-height: 100vh !important;
                height: 100% !important;
                margin: 0px !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            max-height: unset !important;
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
    orderNumberText: {
        css: css`
            font-size: 20px;
        `,
    },
    printButton: {
        css: css`
            font-size: 20px;
        `,
    },
    tittleContainer: {
        css: css`
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        `,
    },
    orderDetailsContainer: {
        css: css`
            display: flex;
            justify-content: space-between;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        margin: 0px;
                        max-width: 100%;
                    `,
                    null,
                    null,
                ])}

            > div[class^="GridOffset"] {
                margin: 0px;
            }
        `,
    },
    firstGrid: {
        width: [12, 12, 12, 3, 3],
        css: css`
            font-size: 12px;
            background-color: #3db34f;
            border-radius: 5px;
            color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 7px;
            font-size: 15px;
        `,
    },
    secondGrid: {
        width: [12, 12, 12, 4, 4],
        css: css`
            display: flex;
            justify-content: space-between;
            padding: 7px;
            font-size: 12px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    thirdGrid: {
        width: [6, 6, 6, 2, 2],
        css: css`
            padding: 7px;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            width: 100%;
        `,
    },
    fourthtGrid: {
        width: [6, 6, 6, 3, 3],
        css: css`
            padding: 7px;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            width: 100%;
        `,
    },
    secondGridFirst: {
        css: css`
            padding: 0px;
            font-size: 12px;
            display: flex;
            justify-content: space-between;
            column-gap: 15px;
        `,
    },
    secondGridlast: {
        css: css``,
    },
    secondGridFirstMain: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
        `,
    },
    orderTable: {
        css: css`
            margin: 10px 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        overflow-x: scroll;
                    `,
                    css`
                        overflow-x: scroll;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    itemsHeader: {
        css: css`
            width: 60%;
        `,
    },
    uomHeader: {
        css: css`
            width: 20%;
        `,
    },
    qtyHeader: {
        css: css`
            width: 20%;
        `,
    },
    photoGallary: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        margin: 0px;
                        max-width: 100%;
                    `,
                    null,
                    null,
                ])}
            > div[class^="GridOffset"] {
                width: 100%;
                margin: 0px;
            }
        `,
    },
    productPhoto: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            margin: 10px 0px;
        `,
    },
    productImage: {
        width: [12, 12, 12, 12, 12],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        justify-content: center;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    deliverdProductText: {
        css: css`
            margin-bottom: 10px;
        `,
    },
    notesSignature: {
        css: css`
            display: flex;
            width: 100%;
            column-gap: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    notes: {
        css: css`
            width: 50%;
            min-height: 50px;
            background: #f4f4f4;
            border-radius: 5px;
            padding: 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    signature: {
        css: css`
            width: 50%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    lastInfo: {
        css: css`
            display: flex;
            flex-direction: column;
            row-gap: 5px;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin: 10px 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        align-items: flex-start;
                    `,
                    css`
                        align-items: flex-start;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    signatureImage: {
        css: css`
            max-height: 70px;
            height: 100%;
            width: 100%;
            img {
                overflow: hidden;
            }
        `,
    },
    receivedText: {
        css: css`
            color: #666;
        `,
    },
    receiveContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        `,
    },
    dateContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
        `,
    },
    orderContainer: {
        css: css`
            width: 50%;
            padding: 7px;
        `,
    },
    personName: {
        css: css`
            font-weight: bold;
        `,
    },
    date: {
        css: css`
            font-weight: bold;
        `,
    },
    nextPreviousContainer: {
        css: css`
            display: flex;
            justify-content: space-between;
            margin: 20px 0px;
        `,
    },
    previousContainer: {
        css: css`
            align-self: flex-start;
        `,
    },
    nextContainer: {
        css: css`
            align-self: flex-end;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    podImage: {
        css: css`
            max-width: 177px;
            max-height: 236px;
            width: 100%;
            height: 100%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        max-height: 100%;
                    `,
                    css`
                        max-width: 100%;
                        max-height: 100%;
                    `,
                    css`
                        max-width: 100%;
                        max-height: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    getItByDate: {
        css: css`
            text-align: center;
        `,
    },
};

const styles = proofOfDeliveryStyles;
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const ProofOfDeliveryComponent: React.FC<Props> = ({
    onHandleClose,
    modalIsOpen,
    loadPODData,
    podData,
    poNumber,
    isLoading,
}) => {
    if (isLoading) {
        <StyledWrapper {...styles.centeringWrapper}>
            <LoadingSpinner {...styles.spinner} />
        </StyledWrapper>;
    }

    const [imageData, setImageData] = React.useState("");
    
    // const imgContainerRef = React.useRef<HTMLDivElement>(null);
    // const [watermark, setWatermark] = React.useState("watermarked");

    // React.useEffect(() => {
    //     if (imgContainerRef.current) {
    //         const imgContainerSelector = imgContainerRef.current?.querySelector(".watermarked") as HTMLElement | null;

    //         if (imgContainerSelector) {
    //             // Now you can safely access the dataset property
    //             imgContainerSelector.dataset.watermark = `${imgContainerSelector.dataset.watermark}   `.repeat(300);
    //         } else {
    //             console.log("imgContainerSelector is null");
    //         }
    //     }
    // }, [watermark]);

    // const removeWatermark = () => {
    //     setWatermark("");
    // };

    React.useEffect(() => {
        const base64String = btoa(String.fromCharCode.apply(null, podData.podImages));
        setImageData(base64String);
    }, [podData]);

    const [podItemsArray, setPodItemsArray] = React.useState([]);

    const [podImagesArray, setPodImagesArray] = React.useState([]);

    React.useEffect(() => {
        if (podData.podItems && podData.podItems.length > 0) {
            setPodItemsArray(podData.podItems);
        }
    }, [podData.podItems]);

    React.useEffect(() => {
        if (podData.podImages && podData.podImages.length > 0) {
            setPodImagesArray(podData.podImages);
        }
    }, [podData]);

    const nextPODHandler = (id: string, podId: string) => {
        if (podId.length > 0) {
            loadPODData({ orderNumber: id, id: podId });
        }
    };

    const previousPODHandler = (id: string, podId: string) => {
        if (podId.length > 0) {
            loadPODData({ orderNumber: id, id: podId });
        }
    };

    const convertImage = (btye: any) => {
        const input = btye.replace(/[^A-Fa-f0-9]/g, "");
        const binary = [];
        for (let i = 0; i < input.length / 2; i++) {
            const h = input.substr(i * 2, 2);
            binary[i] = parseInt(h, 16);
        }
        const byteArray = new Uint8Array(binary);
        const imageUrl = window.URL.createObjectURL(new Blob([byteArray], { type: "application/octet-stream" }));
        return imageUrl;
    };

    return (
        <Modal headline="Proof Of Delivery" isOpen={modalIsOpen} handleClose={onHandleClose} {...styles.podModal}>
                <StyledWrapper {...styles.nextPreviousContainer}>
                    <StyledWrapper>
                        {podData.previousPodId && (
                            <Clickable
                                onClick={() => {
                                    previousPODHandler(podData.orderNumber, podData.previousPodId);
                                }}
                                {...styles.previousContainer}
                            >
                                Previous
                            </Clickable>
                        )}
                    </StyledWrapper>
                    <StyledWrapper>
                        {podData.nextPodId && (
                            <Clickable
                                onClick={() => {
                                    nextPODHandler(podData.orderNumber, podData.nextPodId);
                                }}
                                {...styles.nextContainer}
                            >
                                Next
                            </Clickable>
                        )}
                    </StyledWrapper>
                </StyledWrapper>

                <StyledWrapper {...styles.tittleContainer}>
                    <StyledWrapper {...styles.orderNumberText}>ORDER # {podData.orderNumber}</StyledWrapper>
                    <StyledWrapper {...styles.printButton}>
                        <Clickable
                            {...styles.printClickable}
                            onClick={openPrintDialog}
                            data-test-selector="invoiceDetails_print"
                        >
                            <Icon src={Printer} {...styles.printIcon}></Icon>
                        </Clickable>
                    </StyledWrapper>
                </StyledWrapper>
                <GridContainer {...styles.orderDetailsContainer}>
                    <GridItem {...styles.firstGrid}>
                        <StyledWrapper> Delivered via</StyledWrapper>
                        <StyledWrapper> White Cap Truck</StyledWrapper>
                        {/* podData && 
                            podItemsArray.length > 0 &&
                            podItemsArray.map((item: any, index: number) => (
                                <StyledWrapper key={index} {...styles.getItByDate}>
                                    {item && item.getItByDate ? item.getItByDate : ""}
                                </StyledWrapper>
                            )) */}
                            <StyledWrapper {...styles.getItByDate}>
                                {podData.deliveryDate}
                            </StyledWrapper>

                        <StyledWrapper> {podItemsArray.length} items(s)</StyledWrapper>
                    </GridItem>

                    <GridItem {...styles.secondGrid}>
                        <Hidden below="lg">
                            <StyledWrapper {...styles.secondGridFirstMain}>
                                <StyledWrapper {...styles.secondGridFirst}>
                                    <StyledWrapper>
                                        <StyledWrapper {...styles.receivedText}> RECEIVED BY:</StyledWrapper>
                                        <StyledWrapper>
                                            <StyledWrapper {...styles.personName}>{podData.receivedBy} </StyledWrapper>
                                            <Typography {...styles.date}>{podData.deliveryDate}</Typography>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                    <StyledWrapper>
                                        <StyledWrapper {...styles.receivedText}> ORDER DATE:</StyledWrapper>
                                        <StyledWrapper> {podData.orderDate}</StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                                {/* {poNumber.length > 0 ? ( */}
                                <StyledWrapper {...styles.secondGridlast}>
                                    <StyledWrapper {...styles.receivedText}>PO NUMBER:</StyledWrapper>
                                    {poNumber}
                                </StyledWrapper>
                                {/* ) : null} */}
                            </StyledWrapper>
                        </Hidden>
                        <Hidden above="md">
                            <StyledWrapper {...styles.receiveContainer}>
                                <StyledWrapper {...styles.receivedText}> RECEIVED BY:</StyledWrapper>
                                <StyledWrapper {...styles.dateContainer}>
                                    <StyledWrapper>{podData.receivedBy}</StyledWrapper>
                                    <StyledWrapper>{podData.deliveryDate}</StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                        </Hidden>
                    </GridItem>

                    <Hidden above="md" {...styles.orderContainer}>
                        <StyledWrapper>
                            <StyledWrapper {...styles.receivedText}> ORDER DATE: </StyledWrapper>
                            <StyledWrapper> {podData.orderDate}</StyledWrapper>
                        </StyledWrapper>
                    </Hidden>
                    <Hidden above="md" {...styles.orderContainer}>
                        {/* {poNumber.length > 0 ? ( */}
                        <StyledWrapper {...styles.secondGridlast}>
                            <StyledWrapper {...styles.receivedText}>PO NUMBER:</StyledWrapper>
                            {poNumber}
                        </StyledWrapper>
                        {/* ) : null} */}
                    </Hidden>

                    <GridItem {...styles.thirdGrid}>
                        <StyledWrapper {...styles.receivedText}>CONTACT:</StyledWrapper>
                        <StyledWrapper>{podData.shipToContact}</StyledWrapper>
                        <StyledWrapper>{podData.shipToPhone}</StyledWrapper>
                    </GridItem>

                    {(podData.locationAddress ||
                        podData.locationCity ||
                        podData.locationState ||
                        podData.locationPostalCode) && (
                        <GridItem {...styles.fourthtGrid}>
                            <StyledWrapper {...styles.receivedText}>SHIPPED TO:</StyledWrapper>
                            <StyledWrapper> {podData.locationAddress} </StyledWrapper>
                            <StyledWrapper> {podData.locationCity}</StyledWrapper>
                            <StyledWrapper>
                                {podData.locationState} {podData.locationPostalCode}
                            </StyledWrapper>
                        </GridItem>
                    )}
                </GridContainer>
                {podItemsArray.length > 0 && (
                    <StyledWrapper {...styles.orderTable}>
                        <DataTable>
                            <DataTableHead>
                                <DataTableHeader {...styles.itemsHeader}>Items</DataTableHeader>
                                <DataTableHeader {...styles.uomHeader}>UOM</DataTableHeader>
                                <DataTableHeader {...styles.qtyHeader}>QTY</DataTableHeader>
                            </DataTableHead>
                            <DataTableBody>
                                {podItemsArray.map((item: any, index: number) => (
                                    <DataTableRow key={index}>
                                        <DataTableCell>
                                            <StyledWrapper>{item.description}</StyledWrapper>
                                            <StyledWrapper>{translate("Product#:")} {item.sku}</StyledWrapper>
                                        </DataTableCell>
                                        <DataTableCell>{item.uom}</DataTableCell>
                                        <DataTableCell>{item.quantity}</DataTableCell>
                                    </DataTableRow>
                                ))}
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                )}

                {podImagesArray.filter((podImage: any) => podImage.imageType === "PhotoofDeliveredProduct").length > 0 && (
                    <StyledWrapper {...styles.productPhoto}>
                    <StyledWrapper {...styles.deliverdProductText}>DELIVERED PRODUCT PHOTO:</StyledWrapper>
                    <GridContainer {...styles.photoGallary}>
                        {podImagesArray.filter((podImage: any) => podImage.imageType === "PhotoofDeliveredProduct").map((item: any, index: number) => (
                            <GridItem {...styles.productImage} key={index}>
                                {item.image && <Img src={convertImage(item.image)} {...styles.podImage} />}
                            </GridItem>
                        ))}
                    </GridContainer>
                    </StyledWrapper>
                )}
                

                <StyledWrapper {...styles.notesSignature}>
                    <StyledWrapper {...styles.notes}>
                        <StyledWrapper>DELIVERY NOTES:</StyledWrapper>
                        <Typography>{podData.deliveryNotes}</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.signature}>
                        <StyledWrapper>DELIVERY SIGNATURE:</StyledWrapper>
                        {podImagesArray.map((item: any, index: number) => (
                            <StyledWrapper key={index}>
                                {item.imageType === "Signature" && (
                                    <StyledWrapper
                                        // ref={imgContainerRef}
                                        {...styles.productImage}
                                        key={index}
                                        className="watermarked"
                                        data-watermark="watermark.com"
                                    >
                                        {item.image && (
                                            <Img src={convertImage(item.image)} {...styles.signatureImage} />
                                        )}
                                    </StyledWrapper>
                                )}
                            </StyledWrapper>
                        ))}
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.lastInfo}>{siteMessage("podStaticNotes")}</StyledWrapper>
            </Modal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(ProofOfDeliveryComponent));
